const ConnectionStatus = {
  WAITING: -1,
  CONNECTING: 0,
  OPEN: 1,
  CLOSED: 2,
}

export default ConnectionStatus
